import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getProviderReports(params: any): AxiosPromise {
    return EndPointService.get('/provider-report', { params });
}

function getProviderReport(id: number | string): AxiosPromise {
    return EndPointService.get(`/providerReports/${id}`);
}

function deleteProviderReport(id: number | string): AxiosPromise {
    return EndPointService.delete(`/providerReports/${id}`);
}

function createProviderReport(payload: any): AxiosPromise {
    return EndPointService.post('/providerReports', payload);
}

function updateProviderReport(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/providerReports/${id}`, { ...payload });
}

export default {
    getProviderReports,
    getProviderReport,
    deleteProviderReport,
    createProviderReport,
    updateProviderReport,
};
